import { Instagram } from "lucide-react";

export default function InstagramStrip() {
  return (
    <section data-testid="instagram-strip" className="bg-blush py-14 overflow-hidden">
      <a
        href="https://www.instagram.com/fantasydancefloors"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="instagram-link"
        className="group flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-6"
      >
        <span className="w-12 h-12 rounded-full bg-ivory/20 border border-ivory/40 flex items-center justify-center text-ivory group-hover:bg-ivory/35 group-hover:scale-110 transition-[background-color,transform] duration-300">
          <Instagram size={20} strokeWidth={1.8} />
        </span>
        <span className="font-serif text-3xl sm:text-4xl text-ivory group-hover:text-midnight transition-colors duration-300">
          @fantasydancefloors
        </span>
        <span className="text-[11px] tracking-[0.35em] uppercase text-ivory/80">
          Fresh installs weekly — follow the magic
        </span>
      </a>
    </section>
  );
}
